export class DeviceSetting {
  id: number;
  idSD: number;
  direction: number;
  idCarPark: number;
  name: string;
  deviceIP: string;
  description: string;
}
